import React, { Component } from 'react'

import './style.css';
import { Button } from '@material-ui/core';
import Search from '@material-ui/icons/Search';
import Close from '@material-ui/icons/Close';
import Print from '@material-ui/icons/Print';
import Check from '@material-ui/icons/Check';
import Add from '@material-ui/icons/Add';

import { DialogPesquisa, Spinner } from "scorpion-core";

export default class ContainerCrud extends Component {
  constructor(props) {
    super(props);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.salvarImprimir = this.salvarImprimir.bind(this);
    this.showSuccess = this.showSuccess.bind(this);
    this.showError = this.showError.bind(this);
    this.actionsComponents = this.actionsComponents.bind(this);
  }
  componentDidMount() {
    this.props.setAppBarValues({ titulo: this.props.propsForm.titulo, actions: this.actionsComponents })
  }

  actionsComponents() {
    const { classes, handleSubmit, salvar, imprimir, pesquisa, permiteNovo, sair } = this.props;

    return <span style={{ minWidth: 100, display: "flex", justifyContent: "flex-end", whiteSpace: "nowrap" }}>
      {permiteNovo && <Button className={"header-botao"} variant="contained" color="secondary" onClick={() => {
        this.props.initialize(this.props.initialValues);
        if (this.props.novo) this.props.novo();
      }}> <Add /><div className="responsivo-hidden">Novo</div> </Button>}
      {salvar && imprimir && <Button className={"header-botao"} variant="contained" color="secondary" onClick={handleSubmit(this.salvarImprimir)}> <Print /><div className="responsivo-hidden">Salvar e Imprimir</div></Button>}
      {salvar && <Button className={"header-botao"} variant="contained" color="secondary" onClick={handleSubmit(this.handleFormSubmit)}> <Check /><div className="responsivo-hidden">Salvar</div></Button>}
      {pesquisa && <Button className={"header-botao"} variant="contained" color="secondary" onClick={() => this.pesquisar()} > <Search /><div className="responsivo-hidden">Pesquisar</div> </Button>}
      {sair && <Button className={"header-botao"} variant="contained" color="secondary" onClick={sair} > <Close /><div className="responsivo-hidden">Sair</div> </Button>}
    </span>
  }

  showSuccess(str) {
    this.props.showSuccess(str)
  }
  showError(str) {
    this.props.showError(str)
  }
  pesquisar() {
    if (this.dialog)
      this.dialog.show();
  }
  handleFormSubmit(props) {
    this.props.salvar(props, () => this.props.showSuccess("Salvo com sucesso!"));
  }

  salvarImprimir(props) {
    this.props.salvar(props, (salvou) => {
      this.props.showSuccess("Salvo com sucesso!");
      if (this.props.imprimir) {
        this.props.imprimir(salvou)
      }

    });
  }
  render() {
    const { crudControl } = this.props

    let telaPesquisaInjetada = null;
    if (this.props.pesquisa) {
      telaPesquisaInjetada = React.cloneElement(this.props.pesquisa, {
        selecionar: (item) => {
          this.dialog.hide();
          this.props.destroy();
          this.props.initialize(item);
        }
      })
    }
    return (
      <div style={{flex: 1}}>
        {crudControl && crudControl.crudloading ?
          <Spinner /> :
          this.props.children
        }
        {this.props.pesquisa && <DialogPesquisa forwardedRef={node => this.dialog = node} > {telaPesquisaInjetada}</DialogPesquisa>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ContainerCrud/ContainerCrud.js